/*
* @author 友人a丶
* @date 2022-07-11
*
* 系统是否初始化成功
* */

import {defineStore} from "pinia";

export default defineStore('loaded', {
    state() {
        /*
        * 进入系统时需要判断用户有没有登录
        * 判断完毕，开始加载页面
        * */
        return {
            loaded: false,
            filterRoutes: false, //路由是否已经加载
            title: "",
            url: "",
            zhuce: "",
            zhuce1: "",
            type1: "",
            type2: "",
            type3: "",
            type4: 1,
            type5: "",
            protocol: "",
            gonggao: "",
            clan_gamount: null,
            clan_vamount: null,
            create_clan_gamount: null,
            create_clan_vamount: null
        }
    },
    actions: {
        /*
        * 系统加载完成
        * */
        load() {
            this.loaded = true;
        },
        apply(state) {
            this.$state = Object.assign(this.$state, state);
        }
    }
})